import * as React from 'react';
import { useSelector } from 'react-redux';

import { GallerySectionLayout } from '../../components/GallerySectionLayout';
import { ImageItemContainer } from '../ImageItem';
import { selectNewbuildingName } from '../../selectors/newbuilding';
import { selectConstructionProgress } from '../../selectors/constructionProgress';
import { MAX_GALLERY_IMAGES_LENGTH } from '../../constants/gallery';

export const GalleryContainer: React.FC = () => {
  const constructionProgress = useSelector(selectConstructionProgress);
  const newbuildingName = useSelector(selectNewbuildingName);

  return (
    <>
      {constructionProgress.map(({ date, images }, dateIndex) => {
        const hasMoreImages = images.length > MAX_GALLERY_IMAGES_LENGTH;
        const imagesList = images.slice(0, MAX_GALLERY_IMAGES_LENGTH);

        return (
          <GallerySectionLayout key={date} newbuildingName={newbuildingName} date={date}>
            {imagesList.map((image, index) => (
              <ImageItemContainer
                key={image.fullUrl}
                image={image}
                index={index}
                dateIndex={dateIndex}
                hasMoreImages={hasMoreImages}
              />
            ))}
          </GallerySectionLayout>
        );
      })}
    </>
  );
};
